import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Users,
  Building2,
  User,
  Shield,
  Database,
  MessageSquare,
  Zap,
  Workflow
} from 'lucide-react';

const configuracoes = [
  {
    id: 'minha-conta',
    titulo: 'Minha Conta',
    descricao: 'Gerencie seu perfil e segurança',
    icone: User,
    rota: '/minha-conta'
  },
  {
    id: 'empresa',
    titulo: 'Dados da Empresa',
    descricao: 'Informações empresariais e fiscais',
    icone: Building2,
    rota: '/configuracoes/empresa'
  },
  {
    id: 'usuarios',
    titulo: 'Usuários e Permissões',
    descricao: 'Gerencie operadores e seus acessos',
    icone: Users,
    rota: '/configuracoes/usuarios'
  },
  {
    id: 'permissoes',
    titulo: 'Permissões',
    descricao: 'Configurações de privacidade e acesso',
    icone: Shield,
    rota: '/configuracoes/permissoes'
  },
  {
    id: 'whatsapp',
    titulo: 'Configurações WhatsApp',
    descricao: 'Integração e templates de mensagens',
    icone: MessageSquare,
    rota: '/configuracoes/whatsapp'
  },
  {
    id: 'auditoria',
    titulo: 'Registro de Atividades',
    descricao: 'Visualize histórico de ações do sistema',
    icone: Database,
    rota: '/configuracoes/registro-atividades'
  },
  {
    id: 'assinatura',
    titulo: 'Assinatura e Plano',
    descricao: 'Gerenciamento de sua assinatura',
    icone: Zap,
    rota: '/assinatura'
  },
  {
    id: 'timeline',
    titulo: 'Timeline de Produção',
    descricao: 'Customize as etapas de produção dos pedidos',
    icone: Workflow,
    rota: '/configuracoes/timeline'
  }
];

export function Configuracoes() {
  const navigate = useNavigate();

  return (
    <div className="px-6 py-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Configurações</h1>
        <p className="text-gray-600 mt-2">Gerencie sua conta, empresa e permissões</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {configuracoes.map((config) => {
          const Icon = config.icone;
          return (
            <Card
              key={config.id}
              className="group cursor-pointer border border-gray-200 hover:border-purple-300 transition-all duration-300 hover:shadow-md bg-white hover:bg-gradient-to-br hover:from-purple-50/50 hover:to-pink-50/50"
              onClick={() => navigate(config.rota)}
            >
              <CardHeader className="pb-3">
                <div className="flex items-center gap-3">
                  <div className="p-3 rounded-lg bg-gradient-to-br from-purple-100 to-pink-100 text-purple-600 group-hover:from-purple-200 group-hover:to-pink-200 transition-colors">
                    <Icon className="w-6 h-6" />
                  </div>
                  <CardTitle className="text-base text-gray-900">{config.titulo}</CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-sm text-gray-600">{config.descricao}</CardDescription>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
